import * as yup from "yup"
import type { Keyword } from "../../types"

export function initialValuesKeyword(keyword?: Keyword | undefined) {
  if (keyword) {
    return keyword
  }
  return {
    name: "",
    description: "",
  }
}

export function validationSchemaKeyword() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
  })
}
